import { Portal } from '../Portal/Portal'
import { AnimationFade } from '../Transition/Transition'
import FocusTrap from 'focus-trap-react'
import useKeyPress from '../../hooks/useKeyPress'
import { CloseButton } from 'components/Button/CloseButton'
import { useModalScroll } from 'hooks/useModalScroll'
import React from 'react'

export interface ModalProps {
  children?: React.ReactNode;
  heading: string;
  headingClassNameOverride?: string;
  onClose: () => void;
  testid?: string;
  contentContainerRef: React.RefObject<HTMLElement>
  className?: string;
  backDropClickable?:boolean;
}

const Child = React.forwardRef<HTMLDivElement, ModalProps>(({
  children,
  heading,
  headingClassNameOverride,
  onClose,
  testid,
  contentContainerRef,
  className,
  backDropClickable
}, ref) => {
  return (
    <div ref={ref}>
    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}

    <div role="none" data-testid="modal-backdrop" className="ch-c-dialog__backdrop " onClick={() => {
      if (backDropClickable) {
        onClose()
        // TODO - add some data tracking logic here if needed
      }
    }}/>
    <div className={`${className} ch-c-dialog ds-u-padding--0 ch-u-overflow`} role='document' data-testid={testid}>
      <header
        className='ch-c-dialog__header'
        role='banner'
        data-testid='modal-header'
      >
        <h1 className={headingClassNameOverride || 'ds-text-heading--xl ds-u-font-weight--semibold'} id='dialog-heading'>
          {heading}
        </h1>
      </header>
      <CloseButton onClose={onClose} data-testid='modal-close-btn' />
      <main
        className='ch-c-dialog__main'
        role='main'
        ref={contentContainerRef}
      >
        {children}
      </main>
    </div>
  </div>
  )
})

export const Modal: React.FC<ModalProps> = (props) => {
  useKeyPress('Escape', props.onClose)
  useModalScroll()

  return (
    <Portal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
      className='ch-c-dialog-wrap'
      aria-labelledby='dialog-heading'
      role='dialog'
      aria-modal='true'
      onClick={(e) => {
        e.stopPropagation()
      }}>
        <AnimationFade>
          <FocusTrap>
            <Child {...props} />
          </FocusTrap>
        </AnimationFade>
      </div>
    </Portal>
  )
}
